<template>
  <div class="fill-height overflow-x-hidden" :class="smAndDown ? 'background-mob' : 'background'">
    <v-row style="height: calc(100% - 48px)">
      <v-col cols="12">
        <v-row class="fill-height pa-4" justify="center" align="center">
          <v-col cols="auto">
            <v-card class="background-border" flat height="500" color="background">
              <v-card-title class="d-flex justify-center">
                <v-img :src="logoSrc" max-width="300" class="mt-6">
                  <template v-slot:placeholder>
                    <div class="d-flex align-center justify-center fill-height">
                      <v-progress-circular
                          color="grey-lighten-4"
                          indeterminate
                      ></v-progress-circular>
                    </div>
                  </template>
                </v-img>
              </v-card-title>
              <v-stepper @update:modelValue="activeStep = $event" :model-value="activeStep" flat class="fill-height" id="login-stepper" @change="error = ''" width="380">
                <v-stepper-window :model-value="activeStep">
                  <v-stepper-window-item :value="LoginSteps.EmailPrompt" class="fill-height" selected-class="px-3">
                    <v-row class="fill-height" justify="center" align="center" no-gutters>
                      <v-col cols="12" class="fill-height">
                        <EmailPrompt @checkEmail="username = $event; checkUser();" :loading="loading" :error="error" @clearError="error = ''" :query-username="username"/>
                      </v-col>
                    </v-row>
                  </v-stepper-window-item>
                  <v-stepper-window-item :value="LoginSteps.PasswordPrompt" class="fill-height" selected-class="px-3">
                    <v-row class="fill-height" justify="center" align="center" no-gutters>
                      <v-col cols="12" class="fill-height">
                        <PasswordPrompt
                            :activated="activated"
                            :error="error"
                            :query-code="queryCode"
                            @clearError="error = ''"
                            @goToEmail="activeStep = LoginSteps.EmailPrompt"
                            @checkPassword="password = $event; login()"
                            @goToForgotPassword="activeStep = LoginSteps.ForgotPassword"
                            @goToResendRegistration="activeStep = LoginSteps.ResendRegistration"
                        />
                      </v-col>
                    </v-row>
                  </v-stepper-window-item>
                  <v-stepper-window-item :value="LoginSteps.NewPasswordPrompt" selected-class="px-3">
                    <v-row class="fill-height" justify="center" align="center" no-gutters>
                      <v-col cols="12" class="fill-height">
                        <PasswordPrompt
                            :error="error"
                            @clearError="error = ''"
                            @goToEmail="activeStep = LoginSteps.EmailPrompt"
                            @checkPassword="password = $event; login()"
                            :loading="loading"
                            :activated="activated"
                            :is-new="isNew"
                        />
                      </v-col>
                    </v-row>
                  </v-stepper-window-item>
                  <v-stepper-window-item :value="LoginSteps.ForgotPassword" selected-class="px-3">
                    <v-row class="fill-height" justify="center" align="center" no-gutters>
                      <v-col cols="12" class="fill-height">
                        <ResendPrompt :username="username" @goToEmail="activeStep = LoginSteps.EmailPrompt"/>
                      </v-col>
                    </v-row>
                  </v-stepper-window-item>
                  <v-stepper-window-item :value="LoginSteps.ResendRegistration" selected-class="px-3">
                    <v-row class="fill-height" justify="center" align="center" no-gutters>
                      <v-col cols="12" class="fill-height">
                        <ResendPrompt :username="username" :activating="true" @goToEmail="activeStep = LoginSteps.EmailPrompt"/>
                      </v-col>
                    </v-row>
                  </v-stepper-window-item>
                  <v-stepper-window-item :value="LoginSteps.Loading" class="fill-height">
                    <v-row class="fill-height" justify="center" align="center" no-gutters>
                      <v-col cols="12" class="text-center">
                        <span class="text-primary text-h5 font-weight-bold">Logging you in..</span>
                      </v-col>
                      <v-col cols="auto">
                        <v-progress-circular indeterminate color="white"></v-progress-circular>
                      </v-col>
                    </v-row>
                  </v-stepper-window-item>
                </v-stepper-window>
              </v-stepper>
            </v-card>
<!--            <v-card flat class="background-border pa-4 mt-4 text-center" color="background">
              <span class="text-medium-emphasis text-body-2">Don't have an account? <a href="/signup" variant="plain" :ripple="false" class="pa-0 signup-link text-none mt-n1">Sign up.</a> </span>
            </v-card>-->
          </v-col>
        </v-row>

      </v-col>
    </v-row>
    <v-card flat height="64" color="transparent">
      <v-row justify="center" align="end" class="fill-height">
        <v-col cols="auto" class="mx-4 bottom-link" v-if="helpUrl">
          <a :href="helpUrl" target="_blank" class="bottom-link">Help</a>
        </v-col>
        <v-col cols="auto" class="mx-4 bottom-link" v-if="privacyUrl">
          <a :href="privacyUrl" target="_blank" class="bottom-link">Privacy Policy</a>
        </v-col>
        <v-col cols="auto" class="mx-4 bottom-link" v-if="termsUrl">
          <a :href="termsUrl" target="_blank" class="bottom-link">Terms & Conditions</a>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";
import EmailPrompt from "@/views/login/EmailPrompt.vue";
import PasswordPrompt from "@/views/login/PasswordPrompt.vue";
import LoginService from "@/services/login.service";
import ResendPrompt from "@/views/login/ResendPrompt.vue";
import { LoginResponse } from "../../types";
import { useDisplay } from 'vuetify';
import { useUserStore } from "@/stores/userStore";
import {getHelpUrl, getPrivacyPolicyUrl, getTermsUrl} from "@/util";

enum LoginSteps {
  EmailPrompt = 0,
  PasswordPrompt = 1,
  NewPasswordPrompt = 2,
  ForgotPassword = 3,
  ResendRegistration = 4,
  Loading = 5
}

@Component({
  name: 'login',
  methods: {getHelpUrl, getTermsUrl},
  components: {ResendPrompt, PasswordPrompt, EmailPrompt}
})
export default class LoginFlow extends Vue {
  private LoginSteps = LoginSteps;
  private activeStep = LoginSteps.EmailPrompt;
  private loginData: LoginResponse = {};
  private loading = false;
  private activated = false;
  private activating = false;
  private challenged = false;
  private isNew = false;
  private username = '';
  private password = '';
  private queryCode = '';
  private error = '';
  private smAndDown = useDisplay().smAndDown;

  private mounted() {
    if (this.$route.query.username) {
      this.username = this.$route.query.username.toString();
      if (this.$route.query.code) {
        this.queryCode = this.$route.query.code.toString();
      }

    }
  }

  private async checkUser() {
    this.loading = true;
    this.challenged = false;
    try {
      const userStatus = await LoginService.getUserStatus(this.username);
      switch (userStatus.status) {
        case 'FORCE_CHANGE_PASSWORD':
          this.activated = false;
          this.isNew = true;
          this.activeStep = LoginSteps.PasswordPrompt;
          break;
        case 'UNCONFIRMED':
          this.activated = false;
          this.isNew = false;
          this.activeStep = LoginSteps.PasswordPrompt;
          break;
        case 'OK':
        default:
          this.activated = true;
          this.isNew = false;
          this.activeStep = LoginSteps.PasswordPrompt;
          break;
      }
    } catch (err) {
      this.error = (err as Error).message;
    } finally {
      this.loading = false;
    }
  }

  private async login() {
    this.loading = true
    const oldStep: LoginSteps = this.activeStep;
    this.activeStep = LoginSteps.Loading;
    try {
      if (this.challenged) {
        await this.respondToAuthChallenge(this.loginData);
        return;
      }
      const loginResponse = this.activated ?
        await LoginService.login({username: this.username, password: this.password}) :
        await LoginService.register({username: this.username, code: this.password});
      if (loginResponse.challenge === 'NEW_PASSWORD_REQUIRED') {
        this.challenged = true;
        this.activated = false;
        this.isNew = true;
        this.loginData = loginResponse;
        this.activeStep = LoginSteps.NewPasswordPrompt;
        return;
      }
      if (loginResponse.token) {
        await this.loginSuccess(loginResponse.token);
      }
    } catch (err) {
      this.error = (err as Error).message;
      this.activeStep = oldStep;
    } finally {
      this.loading = false;
    }
  }

  private async respondToAuthChallenge(loginResponse: LoginResponse): Promise<void> {
    this.activeStep = LoginSteps.Loading;
    try {
      const response = await LoginService.respond({
        username: this.username,
        newPassword: this.password,
        challenge: 'NEW_PASSWORD_REQUIRED',
        session: loginResponse.session ? loginResponse.session : '',
        requiredAttributes: loginResponse.requiredAttributes || []
      });
      if (response.challenge) {
        throw new Error(`Unexpected challenge response encountered ${response.challenge}`);
      }
      if (response.token) {
        await this.loginSuccess(response.token);
      }
    } catch (err) {
      this.error = (err as Error).message;
      this.challenged = false;
      this.activeStep = LoginSteps.PasswordPrompt;
    }
  }

  private async loginSuccess(JWT: string) {
    await useUserStore().userLogin(JWT);
  }

  private get logoSrc() {
    return require(`../../assets/${process.env.VUE_APP_FRAMEWORK_HOST}.png`);
  }

  private get helpUrl() {
    return getHelpUrl();
  }

  private get privacyUrl() {
    return getPrivacyPolicyUrl();
  }

  private get termsUrl() {
    return getTermsUrl();
  }

}
</script>

<style>
  #login-stepper {
    background-color: transparent;
    height: calc(100% - 132px) !important;
  }
  #login-stepper .v-stepper__wrapper {
    height: 100% !important;
  }
  #login-stepper .v-stepper-window {
    height: 100% !important;
    margin: 0
  }

  #login-stepper .v-stepper-window .v-window__container,  #login-stepper .v-stepper-window .v-window__container .v-window-item {
    height: 100% !important;
  }
  .centered {
    height: 100%;
  }
  .background-border {
    border-width: 2px !important;
    border-style: solid !important;
    border-color: rgba(var(--v-theme-surface-variant), 1) !important;
  }
  .signup-link {
    color: rgb(var(--v-theme-primary)) !important;
    text-decoration: none;
  }
  .signup-link:hover {
    color: rgba(var(--v-theme-primary), 0.6) !important;;
    text-decoration: none;
    cursor: pointer;
  }
  .bottom-link {
    color: rgb(var(--v-theme-primary)) !important;;
    text-decoration: none;
  }
  .bottom-link:hover {
    color: rgba(var(--v-theme-primary), 0.6) !important;;
    text-decoration: none;
    cursor: pointer;
  }
  .background {
    background-color: #fafafb;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
  .background-mob {
    background-color: #fafafb;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
  .z99 {
    z-index: 99;
  }
  .center {
    transform: translateX(calc(100vw - 75%));
  }

</style>